import { useState } from "react";
import { Tag, Table, Typography, Button, Row, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import TableTitle from "./table-title";
import moment from "moment-timezone";
import { TableContainer } from "./elements";
import { useQuery } from "@apollo/client";
import { GET_ZONES } from "./requests";
import EditZone from "./compoments/editModal";
import CreateZone from "./compoments/createModal";
import { zoneTypes } from "../../types";

const { Title, Text } = Typography;

const Zones = () => {
  const [pageConfig, setPageConfig] = useState({
    pageSize: 10,
    page: 1,
  });
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [zoneSelected, setZoneSelected] = useState<typeof zoneTypes.zone | null>(null);
  const [nameFilter, setNameFilter] = useState<string>("");

  const {
    data: allZones,
    loading,
    refetch,
  } = useQuery(GET_ZONES, {
    variables: {
      params: pageConfig,
      name: nameFilter,
    },
  });
  const zones = allZones?.zones?.results ?? [];

  const columns = [
    {
      title: "Nombre",
      key: "name",
      render: (row) => (
        <Title level={5}>{row?.name}</Title>
      ),
    },
    {
      title: "Municipios",
      key: "subZones",
      render: (row) => (
        <Title level={5}>{row?.subZones.length}</Title>
      ),
    },
    {
      title: "Fecha",
      key: "createdAt",
      width: 150,
      render: (row) => (
        <Tag color="blue">{moment(row?.createdAt).format("D MMM YYYY")}</Tag>
      ),
    },
    {
      title: "",
      key: "acciones",
      width: "15%",
      render: (row) => (
        <Row>
          <Tooltip placement="top" title="Editar">
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              style={{ margin: 5 }}
              size="large"
              onClick={() => {
                setZoneSelected(row);
                setShowEditModal(true);
              }}
            />
          </Tooltip>
        </Row>
      ),
    },
  ];

  return (
    <TableContainer>
      <Table
        title={() => (
          <TableTitle
            setNameFilter={setNameFilter}
            setShowCreateModal={setShowCreateModal}
          />
        )}
        loading={loading}
        dataSource={zones ?? []}
        columns={columns}
        rowKey="id"
        scroll={{ y: "63vh" }}
        pagination={{
          current: Number(pageConfig.page),
          defaultCurrent: pageConfig.page,
          pageSize: Number(pageConfig.pageSize),
          defaultPageSize: pageConfig.pageSize,
          total: allZones?.zones?.info?.count,
          showTotal: (total) => <Text disabled>{`${total} resultados`}</Text>,
          onChange: (page, pageSize) => {
            setPageConfig({
              page,
              pageSize,
            });
          },
          showSizeChanger: true,
        }}
      />
      <CreateZone
        showModal={showCreateModal}
        setShowModal={setShowCreateModal}
        refetch={refetch}
      />
      <EditZone
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        zone={zoneSelected}
        refetch={refetch}
      />
    </TableContainer>
  );
};

export default Zones;
